import { ChangeEvent, ReactNode, useRef } from 'react';
import { Button } from '@dynamika-shared/ui/Button/Button';
import { twMerge } from '@dynamika-shared/utils/twMerge';

type AttachFileButtonProps = {
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  accept?: string;
  multiple?: boolean;
  children?: ReactNode;
  className?: string;
  iconClassName?: string;
};

export const AttachFileButton: React.FC<AttachFileButtonProps> = ({
  onChange,
  accept,
  multiple = true,
  children,
  className,
  iconClassName,
}) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Button
      className={twMerge(
        '!bg-white hover:!bg-dodgerBlue text-dimGray !font-normal h-4 !rounded-[8px]',
        className
      )}
      iconPosition='start'
      iconType='attach'
      iconClassName={twMerge('w-2.5 h-2.5', iconClassName)}
      onClick={handleClick}
    >
      {children}
      <input
        className='hidden'
        type='file'
        ref={fileInputRef}
        multiple={multiple}
        accept={accept}
        onChange={onChange}
      />
    </Button>
  );
};
